import type { IconProps } from "./types";

const SquareCutInto3PiecesIcon = ({
  width,
  size,
  height,
  style = {},
  color,
  noPointer,
  title,
  ...props
}: IconProps) => (
  <svg
    {...props}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
    style={style}
  >
    <title>{title}</title>
    <g
      id="DESIGNS-+-Proto"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path d="M-2-2h24v24H-2z" />
      <g fillRule="nonzero">
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          d="M3 2a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1H3zm0-2h14a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"
        />
        <path
          fill="#D8D8D8"
          stroke={color || "var(--color-easil-gray-x-dark)"}
          d="M10.5 1.5h-1v17h1v-8h7v-1h-7z"
        />
      </g>
    </g>
  </svg>
);

export default SquareCutInto3PiecesIcon;
